import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { DetailsDashboard } from "../../../common/details-dashboard/details-dashboard-layout";
import { TablePagination } from "../../../common/details-table/table-pagination.component";
import { MODAL_CUSTOM_MESSAGE, Selected_Index, TABLE_PAGINATION_KEY, COST_ALLOCATION_TYPE } from "../../../../constants/external-constants";
import { NoSubscription } from "../../dashboard/no-subscription/no-subscription.component";
import { glCodeActions } from "../../../../store/external/finance/gl-code.reducer";
import ModalContainer from "../../../common/modal/modal-container/modal-container.component";
import DetailContainer from "../../../common/Layout/details/DetailsLayout.component";
import GLCodeForm from "./modal-form/cost-allocation-form/gl-code-form.component";
import CostAllocationHistoryLayout from "./modal-form/cost-allocation-form/history/cost-allocation-history-layout.component";
import { ConfirmationNotificationModal } from "../../../common/modal/confirmation-modal.component";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { isObjectEqual, validateAccessModule } from "../../../../utils/helpers.utils";
import { glCodeDetailsActions } from "../../../../store/external/finance/glcode-details/gl-code-details.reducer"
import { TRANSLATIONS as translation } from '../../../../utils/constant.utils';
import { ConfirmationModal } from "../../../common/modal/modal.component";
import { NotificationModal } from "../../../common/modal/notification-modal.component";
import { Loading } from "../../../common/loading";


class GLCode extends Component {
    constructor(props) {
        super(props);

        this.displaySearchBox = this.displaySearchBox.bind(this)
        this.ConfirmationModal = React.createRef();

        this.state = {
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            detailsView: false,
            employeeId: 0,
            contentIndex:  Selected_Index.i_Zero,
            activeTab: Selected_Index.i_Zero, 
            userId: 0,
            showModal: false,
            glCodeId: 0,
            item: {},
            isNew: false,
            costAllocationType: COST_ALLOCATION_TYPE.GlCode,

            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isSaving: false,
            isLoading: true,
        }
    }
    onClickExtract = (e) => {  
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractGLCode();
        }
    };

    async componentDidMount() {
        await this.props.getGLCode();
        this.setState({ isLoading : false})
    }

    componentWillUnmount() {
        this.props.setDefaultGLCode();
        this.props.getGLCode(0, true)
    }

    displaySearchBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    resizePage = (value) => {
        const { getGLCode, resizeGLCodePage } = this.props;
        resizeGLCodePage(value);
        getGLCode();
    }

    applyFilter = (isApply, isReset = false) => {
        const { getGLCode, applyGLCodeFilter, glCode } = this.props;
        isApply = isApply && glCode.glCodeTableFilterList.length;
        applyGLCodeFilter(isApply);
        (isApply || isReset || !glCode.glCodeTableFilterList.length) && getGLCode();
    }

    handleRowClick = (data) => {
        this.setState({
            showModalForm: true,
            glCodeId: data.GLCodeId,
            item: data
        })
    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif, isNew } = this.state;
        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });

    }

    disableSaveChanges = () => {
        const { glCodeDetailsForm, $form } = this.props;
        const { isNew } = this.state

        const initialRequired = glCodeDetailsForm.glCode === '' || glCodeDetailsForm.glCode == null || glCodeDetailsForm.glCode.toString().trim() === '' ||
            glCodeDetailsForm.status === '' || glCodeDetailsForm.status == null;

        const disableSaveChanges = isObjectEqual($form.value, glCodeDetailsForm) ? true : false;

        if (isNew) {
            return initialRequired;
        } else {
            return initialRequired || disableSaveChanges;
        }

    }
    onClickSaveModal = async (glcodeId, validate = 1) => {
        const { saveGlCodeDetails, getGlCodeDetailsForm, glCodeDetailsForm, getGLCode } = this.props;

        this.setState({
            isSaving: true
        });

        var result = await saveGlCodeDetails(glcodeId, validate);
        this.setState({
            isSaving: false
        });

        if (result.success) {
            if (result.isValid) {
                const confirmMessage = this.toLocaleLanguage("save_confirmation");
                const modalTitle = this.toLocaleLanguage("call_save", false);
                var confirmAction = () => this.onClickSaveModal(glCodeDetailsForm.glCodeId, 0);
                this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                return;
            }
            else {
                var isNewGlCode = this.state.glCodeId == 0;

                const successMessage = isNewGlCode ? this.toLocaleLanguage("gl_code_has_been_created") : this.toLocaleLanguage("gl_code_has_been_updated");
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title"), successMessage);

                const data = result.data;
                getGlCodeDetailsForm(data.glCodeId)
                getGLCode()
               this.setState({ isNew: false, glCodeId: data.glCodeId });

                return;
            }
        }
        else if (result.IsExist) {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), this.toLocaleLanguage("gl_code_exist"));
            return;
        }
        else if (!result.success) {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
            return;

        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleCloseForm = () =>{
       
    }

    handleSelectedIndex = (index) =>{
        this.setState({contentIndex: index})      
    }

    handleCreateNewAction=()=>{
        this.setState({
            showModal: true,
        })   
    }

    handleCreateNewConf(buttonType){
        if(buttonType==="ok")
        {
            this.setState({
                showModalForm: true,
                showModal: false,
                isNew: true,
                glCodeId: 0
            }) 
        } else {
            this.setState({showModal: false })
        }
     }

    handleCloseFormModal = () => {
        this.setState({ showModalForm: false, contentIndex: Selected_Index.i_Zero, isNew: false, glCodeId: 0 })
        this.props.resetNewGlCodeForm();
    }

    render() {
        const { glCode, getGLCode, sortGLCodeItems, setGLCodeColSearchStr, addGLCodeFilter, removeGLCodeFilter, glCodeDetailsForm, $form, getGlCodeDetailsForm, glCodeDetails } = this.props;
        const { glCodeId, costAllocationType } =this.state;
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceCostAllocationDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceCostAllocationDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceCostAllocationDashboardRW])

        const { contentIndex } = this.state;

        return (
            <>        
            <DetailsDashboard
                // Filter Properties
                data={glCode.glCodeItems.TableFilterData}
                translation={""}
                addAction={addGLCodeFilter}
                removeAction={removeGLCodeFilter}
                applyAction={this.applyFilter}
                isCreateButtonHidden={false}
                isCustomColumns={true}
                customClassName={"cost-allocation"}
                    //Create New
                createNewAction={this.handleCreateNewAction}
                //View Search Textbox
                viewSearchAction={this.displaySearchBox}
                //Customize Column
                firstList={null}
                secondList={null}
                defaultList={null}
                saveAction={()=>{}}

                //Extract Button
                extractAction={(e) => this.onClickExtract(e)}

                //Access Type
                isReadOnly={isReadOnly}
                isReadAndExtractOnly={isReadAndExtractOnly}
                isReadAndWrite={isReadAndWrite}
                >
            {
                this.state.isLoading ?
                   (<Loading />) :
                     (
                      <TablePagination
                        key={TABLE_PAGINATION_KEY.glCode}
                        classNameWrapper="overflow-auto"
                        columns={glCode.glCodeItems.Headers}
                        pageList={glCode.glCodeItems.Data}
                        pages={glCode.glCodeItems.Pagination}
                        rowClickAction={(item) => { this.handleRowClick(item) }}
                        paginationAction={getGLCode}
                        onColumnClick={sortGLCodeItems}
                        onColumnSearch={() => { getGLCode(0) }}
                        onColumnSearchChange={setGLCodeColSearchStr}
                        isColSearchShow={this.state.displaySearch}
                        resizePage={this.resizePage}
                        totalPage={glCode.glCodeItems.Pagination.TotalEntries}
                        hideStatusIcon={true}
                    />
                    )
            }
            </DetailsDashboard>
            <ConfirmationNotificationModal 
                    show={this.state.showModal} 
                    message={MODAL_CUSTOM_MESSAGE.create_new_gl_code} 
                    title={'Add New'}
                    handleModal={this.handleCreateNewConf.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

            <ConfirmationModal
                    ref={this.ConfirmationModal}
                    title={this.state.saveModal.title}
                    messageBody={this.state.saveModal.messageBody}
                    confirmAction={this.state.saveModal.confirmAction}
                    closeLabel={this.toLocaleLanguage("cancel_button", false)}
                    confirmLabel={this.toLocaleLanguage("yes_button", false)}
                    disabled={this.state.isSaving}
            />

            <NotificationModal
                    show={this.state.saveNotif.show}
                    title={this.state.saveNotif.title}
                    message={this.state.saveNotif.message}
                    handleModal={() => this.toggleSaveNotif(false)}
                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                />

                <ModalContainer
                        title="gl_code"
                        show={this.state.showModalForm}
                        handleModal={this.handleCloseFormModal}
                        hideBtn={contentIndex === Selected_Index.i_One || glCodeDetails.fetchFormInProgress ? true : false}
                        saveDetails={this.onClickSaveModal}
                        customClass="cost-allocation-details__modal modal-form__container"
                        disabled={this.disableSaveChanges()}

                        //Access Type
                        isReadOnly={isReadOnly}
                        isReadAndExtractOnly={isReadAndExtractOnly}
                        isReadAndWrite={isReadAndWrite}
                >

                    <div className="data-table">
                        <DetailContainer
                            renderTabContent={this.handleSelectedIndex}
                            urlIndex={this.state.activeTab}
                            listTab={[
                                {
                                    "id": Selected_Index.i_Zero,
                                    "label": "Details",
                                    "hidden": false
                                },
                                {
                                    "id": Selected_Index.i_One,
                                    "label": "History",
                                    "hidden": false,
                                    "disable": this.state.isNew ? true : false
                                },

                            ]}
                        >

                            {contentIndex === Selected_Index.i_Zero && <GLCodeForm glCodeId={this.state.glCodeId} isNew={this.state.isNew} />}
                            {contentIndex === Selected_Index.i_One && <CostAllocationHistoryLayout glCodeId={glCodeId} hideCustomColumn={true} costAllocationType={costAllocationType} 
                                                                                                    //Access Type
                                                                                                    isReadOnly={isReadOnly}
                                                                                                    isReadAndExtractOnly={isReadAndExtractOnly}
                                                                                                    isReadAndWrite={isReadAndWrite}
                                                                      />}
                        </DetailContainer>
                    </div>

                </ModalContainer>
            </>
        );
    }
}
export default withRouter(connect(
    state => {
        const {
            glCode
            , glCodeDetails
            , form: { forms: { glCodeDetailsForm: { $form } } }
        } = state;
        const { glCodeDetailsForm } = state.form;

        return {
            glCode
            , glCodeDetails
            , glCodeDetailsForm
            , $form
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, glCodeActions, glCodeDetailsActions),
        dispatch
    )
)(GLCode));